export const imageCodes = {
    member: {
        code: "${merchantId}_tmpl_img_23",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F29card1.png?alt=media&token=83635ede-a26c-4ad1-b406-1f8b7ee2dba1",
    },

    appStore: {
        code: "${merchantId}_tmpl_img_24",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fappstore2.jpg?alt=media&token=d41baf41-daa1-4baa-9648-3ed0e72c2c93",
    },

    googlePlay: {
        code: "${merchantId}_tmpl_img_25",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fplaystore.jpg?alt=media&token=13355538-0d70-49a6-a135-9894ad81a4f5",
    },

    reward1: {
        code: "${merchantId}_tmpl_img_26",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Freward1.jpg?alt=media&token=9392c8a1-62bb-4726-a414-3318abab1249",
    },

    reward2: {
        code: "${merchantId}_tmpl_img_27",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Freward2.jpg?alt=media&token=02726f5b-a3b4-4e40-b06f-c619534b097f",
    },

    reward3: {
        code: "${merchantId}_tmpl_img_28",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Freward3.jpg?alt=media&token=0cd58f9b-bc5e-417b-a87a-73a2f561474c",
    },

    loyalty1: {
        code: "${merchantId}_tmpl_img_29",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmembership1.png?alt=media&token=f71616f0-7b89-43a5-8634-bae407304d26",
    },

    loyalty2: {
        code: "${merchantId}_tmpl_img_30",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmembership2.png?alt=media&token=e2a39cbe-70e0-4979-8101-cb13749aaa19",
    },

    loyalty3: {
        code: "${merchantId}_tmpl_img_31",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmembershiop3.png?alt=media&token=bd2b320e-149a-4afa-9827-f014177a1d3f",
    },
}


export const titleCodes = {
    loyaltyTitle: {
        code: "${merchantId}_tmpl_title_8",
        title: "Digital Membership"
    },

    rewardTitle: {
        code: "${merchantId}_tmpl_title_9",
        title: "Rewards"
    },
}

export const textCodes = {

    joinOur: {
        code: "${merchantId}_tmpl_text_31",
        text: "Join Our"
    },

    loyaltyDes1: {
        code: "${merchantId}_tmpl_text_32",
        text: "29 ရတနာ မှာ ​စျေးဝယ်တိုင်း point ​တွေစုပြီး reward ​တွေနဲ့ ပြန်လဲလှယ်လို့ ရ​နေပြီ​နော် ..."
    },

    loyaltyDes2: {
        code: "${merchantId}_tmpl_text_33",
        text: "ပွိုင့်စုဖို့အတွက် နည်းလမ်း​လေးကို​တော့ video ​လေးမှာ အ​သေးစိပ်ကြည့်ရှုနိုင်ပါတယ်ရှင်။"
    },

    rewardDes: {
        code: "${merchantId}_tmpl_text_34",
        text: "100,000 ဖိုး ဝယ်ယူတိုင်း 1 point ရရှိပါမည်"
    },

    expire: {
        code: "${merchantId}_tmpl_text_35",
        text: "* point will expire after 12 months"
    },

    rewardText1: {
        code: "${merchantId}_tmpl_text_36",
        text: "ရွှေကလစ်အ​သေး"
    },

    rewardPoint1: {
        code: "${merchantId}_tmpl_text_37",
        text: "15 points"
    },

    rewardText2: {
        code: "${merchantId}_tmpl_text_38",
        text: "ရွှေဆွဲသီး"
    },

    rewardPoint2: {
        code: "${merchantId}_tmpl_text_39",
        text: "70 points"
    },

    rewardText3: {
        code: "${merchantId}_tmpl_text_40",
        text: "ရွှေကလစ်အကြီး"
    },

    rewardPoint3: {
        code: "${merchantId}_tmpl_text_41",
        text: "80 points"
    },

    rewardText4: {
        code: "${merchantId}_tmpl_text_42",
        text: "ရွှေလက်စွပ်"
    },

    rewardPoint4: {
        code: "${merchantId}_tmpl_text_43",
        text: "150 points"
    },

    rewardText5: {
        code: "${merchantId}_tmpl_text_44",
        text: "Special Gift"
    },

    rewardPoint5: {
        code: "${merchantId}_tmpl_text_45",
        text: "160 points"
    },

    memberCard: {
        code: "${merchantId}_tmpl_text_46",
        text: "Digital Member Card"
    },

    pointSystem: {
        code: "${merchantId}_tmpl_text_47",
        text: "Digital Point System"
    },

    memberShop: {
        code: "${merchantId}_tmpl_text_48",
        text: "Member Shop"
    },

    earnPointsMember: {
        code: "${merchantId}_tmpl_text_49",
        text: "—— Earn Points"
    },
}



export const videoCodes = {
    memberVideo: {
        code: "${merchantId}_tmpl_video_2",
        video: "https://www.youtube.com/embed/TmB9Mt3WNlk"
    },
}